import DialogQueue from "@/module/commons/dialog-queue";
import { isEmpty } from "lodash";

export default {
    data() {
        return {
            currentDialog: null,
            previousDialog: null,
            key: 0
        };
    },
    mounted() {
        this.$root.$on("dialog-closed", this.closeDialog);
        window.addEventListener("storage", this.syncDialogs);
    },
    beforeDestroy() {
        window.removeEventListener("storage", this.syncDialogs);
    },
    methods: {
        enqueueAndShowDialog(dialogKey, labResponse) {
            if (!isEmpty(this.currentDialog)) {
                DialogQueue.enqueueDialog(dialogKey, labResponse);
            } else {
                this.currentDialog = dialogKey + this.key++;
                this.showDialog(dialogKey, labResponse);
            }
        },
        showDialog(dialogKey, labResponse) {
            let self = this;
            this.$nextTick(() => {
                if (self.$refs[dialogKey]) {
                    self.$refs[dialogKey]?.open(labResponse);
                } else {
                    console.log(`error loading dialog ${dialogKey}`);
                }
            });
        },
        closeDialog() {
            // In some occurance, closeDialog is executed multiple times when a dialog is closed
            // hence need to check between previousDialog and currentDialog in order to prevent
            // unnecessary bugs
            if (this.previousDialog == this.currentDialog) {
                return;
            }

            // get next dialog
            let nextDialog = DialogQueue.getNextDialog();

            // if nextDialog is not available reset currentDialog & queueDialog
            if (!nextDialog) {
                this.currentDialog = null;
                this.previousDialog = null;
                nextDialog = DialogQueue.dequeueDialog();
            }

            // check if refs[nextDialog] is available
            if (nextDialog && !isEmpty(this.$refs[nextDialog?.dialogKey])) {
                this.previousDialog = this.currentDialog;
                this.currentDialog = nextDialog.dialogKey + this.key++;
                nextDialog = DialogQueue.dequeueDialog();
                this.showDialog(nextDialog.dialogKey, nextDialog.labResponse);
            }
        },
        syncDialogs(event) {
            if (event.key === "dialogQueue") {
                if (!this.currentDialog) {
                    const nextDialog = DialogQueue.getDialogQueue()[0];
                    if (nextDialog) {
                        this.currentDialog = nextDialog.dialogKey + this.key++;
                        this.showDialog(
                            nextDialog.dialogKey,
                            nextDialog.labResponse
                        );
                    }
                }
            }
        }
    }
};
